import {Component, Input, OnInit} from '@angular/core';
import {CarrierService} from '../services/carrier.service';
import {AuthWebService} from '../services/authweb.service';
import {Router, Params, ActivatedRoute} from '@angular/router';
import {Overlay, OverlayContainer, ToastrService} from 'ngx-toastr';
import {PopupService} from '../services/shared/popup.service';
import {UtilityServiceService} from '../services/utility-service.service';
import {SelectorListContext} from '@angular/compiler';
import {CommonModule} from '@angular/common';
import {PermitService} from '../services/permit.service';
import {SharedModule} from 'app/shared.module';
import {ApplicationService} from '../services/application.service';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {ConfirmDialogService} from '../services/shared/confirm-dialog/confirm-dialog.service';
import {FilterService} from 'app/shared/filter/filter.service';
import {ToastNotificationService} from 'app/shared/toast-notification/toast-notification.service';
import {CARRIER_ACTIONS, CARRIER_ACTION_TYPES} from 'app/shared/actions/actions.constants';

declare var $: any;

@Component({
    selector: 'app-ca-landing-page',
    templateUrl: './ca-landing-page.component.html',
    styleUrls: ['./ca-landing-page.component.scss'],
})
export class CaLandingPageComponent implements OnInit {
    countIndexes = [];
    dataCntrl: any = {
        carrierID: -1,
        carrier: {},
        applications: [],
        applicationtype: {},
        vehicles: [],
        applicationId: -1,
    };
    aCarrier: any = {};
    isPhonePortrait = false;
    subIndex: any;
    isHandsetLandscape = false;
    isLoading: boolean = false;
    isEmpty: boolean = false;
    listAccounts: any = [];
    listCarriers: any = [];
    user: any = {};
    selectedcarrier: any = null;
    page = 1;
    pageSize: number = 5;
    keyword: any = {};
    direction: boolean = false;
    criteria = 'DateSubmitted';
    actions = CARRIER_ACTIONS;
    flags = {flagAN: 1, flagNM: 1, flagLU: 1, flagCT: 1, flagST: 1, flagDS: 1};
    ranks = {flagAN: 1, flagNM: 2, flagLU: 3, flagCT: 4, flagST: 5, flagDS: 6};
    sortLabels = {
        flagAN: 'AccountNumber',
        flagNM: 'Name',
        flagLU: 'LeadUser',
        flagCT: 'CarrierType',
        flagST: 'Status',
        flagDS: 'DateSubmitted',
    };
    count: number = 0;
    rankCtrl: number = 2;
    message: any;
    AccountStatus2: number = 0;
    smCode: any = '';
    individualCarrierId: number;
    isPermit: boolean = false;
    carrierId: any = '';
    carrierName: any = '';
    carrierTradingName: any = '';
    carrierType: any = '';
    carrierCountry: any = '';
    currentPage = 1;
    emptyCarrier: boolean = false;
    fetchedCarrier: boolean = false;

    errorMessage: any = '';
    importingCarrier: string = 'false';

    appId = 0;
    ocausId: number;
    onboarding: number = 0;
    hideSideMenu = false;
    checked: boolean;
    selectedIndex: number;
    selectedSub: number;
    sortDir = 1;
    subsidiaryDataByIndex;

    constructor(
        private carrierService: CarrierService,
        private authWebService: AuthWebService,
        public router: Router,
        public utility: UtilityServiceService,
        private toaster: ToastrService,
        private showModal: PopupService,
        private responsive: BreakpointObserver,
        private toastService: ToastNotificationService,
        private activeRoute: ActivatedRoute,
        private msg: ToastrService,
        private confirmDialogService: ConfirmDialogService,
        private filterCarrier: FilterService
    ) {
        this.toaster.clear();
        this.user = this.authWebService.userData
            ? this.authWebService.userData.User
            : null;
        console.log('User Data', this.user);
        console.log('Username', this.user.UserName);
        console.log('EmailAddress', this.user.EmailAddress);
        console.log('EmailAddress created ', 'Facebook_' + this.user.UserName);
        if (this.user.MobileNumber === null || this.user.EmailAddress == null) {
            //&& this.user.email == ""

            this.router.navigate(['/ammenduser']);
        }
    }

    ngOnInit() {
        this.isPermit = this.router.url.indexOf('accounts') > 0;
        this.searchCarrier();
        this.utility.page = 1;
        this.activeRoute.params.subscribe((params: Params) => {
            this.smCode = params['id'];
        });

        this.responsive
            .observe([Breakpoints.HandsetLandscape, Breakpoints.TabletLandscape])
            .subscribe((result) => {
                this.hideSideMenu = false;
                this.isPhonePortrait = false;
                this.isHandsetLandscape = false;

                if (result.matches) {
                    this.isPhonePortrait = true;
                }
                if (result.matches) {
                    this.isHandsetLandscape = true;
                }
            });

        this.utility.showstatementfooter = false;
        this.loadAccounts(this.pageSize, (this.utility.page = 1));

        this.AccountStatus2 = parseInt(
            this.authWebService.userData.Configurations.find(
                (c) => c.Code == 'AccountStatus2'
            ).Value
        );
        this.onboarding = parseInt(
            this.authWebService.userData.Configurations.find(
                (c) => c.Code == 'ONBOARD'
            ).Value
        );
        this.activeRoute.params.subscribe((params: Params) => {
            this.dataCntrl.carrierID = params['id'];
        });
        if (this.router.url.indexOf('cancel') > 0) {
            this.activeRoute.params.subscribe((params: Params) => {
                this.dataCntrl.carrierID = params['id'];
                this.appId = params['appid'];
            });
        }
        var input = document.getElementById('searchButton');
        input?.addEventListener('keyup', function (event) {
            if (event.key === '13') {
                event.preventDefault();
                document.getElementById('searchButton')?.click();
            }
        });
    }

    showAccount = (page: number = 1, pageSize: number = 5) => {
        this.isLoading = true;
        this.carrierService
            .listCarrierAccountsByUserId(
                this.user.Id,
                page,
                pageSize,
            )
            .subscribe(
                (result: any) => {
                    this.listAccounts = result.data;
                    this.count = result.count;
                    this.utility.onSort(1);
                    // this.isLoading = false;
                    console.log(result, 'HOLE_DATA&&&&&&&&&&&&&&7');

                    console.log(this.listAccounts, 'ACCOUNT_ID##########');
                    this.isLoading = false;

                });

        (error) => {
            //console.log('Error occured: ' + error);
            this.isLoading = false;
        }

    };

    onSort(rank: number) {
        this.direction = !this.direction;
        this.rankCtrl = rank;
        //this.onExcuteSort(rank);
        this.loadAccounts(this.utility.page, this.pageSize);
    }

    onResetFlags() {
        this.flags = {
            flagAN: 1,
            flagNM: 1,
            flagLU: 1,
            flagCT: 1,
            flagST: 1,
            flagDS: 1,
        };
    }

    onExcuteSort(rank: number) {
        this.onResetFlags();
        let sort = this.direction ? 3 : 2;
        this.criteria = null;
        switch (rank) {
            case this.ranks.flagAN: {
                this.criteria = this.sortLabels.flagAN;
                this.flags.flagAN = sort;
                break;
            }
            case this.ranks.flagNM: {
                this.criteria = this.sortLabels.flagNM;
                this.flags.flagNM = sort;
                break;
            }
            case this.ranks.flagLU: {
                this.criteria = this.sortLabels.flagLU;
                this.flags.flagLU = sort;
                break;
            }
            case this.ranks.flagCT: {
                this.criteria = this.sortLabels.flagCT;
                this.flags.flagCT = sort;
                break;
            }
            case this.ranks.flagST: {
                this.criteria = this.sortLabels.flagST;
                this.flags.flagST = sort;
                break;
            }
            default: {
                this.criteria = this.sortLabels.flagDS;
                this.flags.flagDS = sort;
                break;
            }
        }
    }


    loadAccounts = (page: number = 1, pageSize: number = 5) => {
        if (this.user) {
            this.isLoading = true;

            this.carrierService.listCarrierAccountsByUserId(this.user.Id, page, pageSize).subscribe(
                (result: any) => {
                    console.log(result);
                    this.listAccounts = result.data;
                    this.count = result.count;
                    this.utility.onSort(1);
                    if (this.smCode == 'NEWAPP' && result.length == 1) {
                        this.viewAcc(result[0], '/carrier/permit/application');
                        this.isLoading = false;
                        return false;
                    }
                    if (
                        result.length > 1 ||
                        (this.smCode != '' && this.smCode != undefined)
                    ) {
                        console.log(result);
                        this.listAccounts = result.data;
                        console.log('Accounts List', this.listAccounts);
                        for (let list of this.listAccounts) {
                            if (list.subsidiaries.length > 0) {
                                for (let subsidiary of list.subsidiaries) {
                                    let indexToRemove = this.listAccounts.findIndex(
                                        (item) => item.id === subsidiary.id
                                    );

                                    if (indexToRemove !== -1) {
                                        this.listAccounts.splice(indexToRemove, 1);
                                    }
                                }
                            }
                            if (parseInt(list.account_balance) != 0) {
                                list.account_balance = -parseInt(list.account_balance);
                            }
                        }

                        setTimeout(() => {
                            $('#dt-all-checkbox').dataTable({
                                columnDefs: [
                                    {
                                        targets: 0,
                                        orderable: false,
                                        className: 'select-checkbox select-checkbox-all',
                                    },
                                ],
                                dom: 'rtipl',
                                // dom: '<"top"i>rt<"bottom"lp><"clear">',
                                language: {
                                    info: '_START_   /   _END_ of    _TOTAL_ ',
                                    lengthMenu: 'Show _MENU_',
                                    paginate: {
                                        first: 'First',
                                        last: 'Last',
                                        next: 'Next',
                                        previous: 'Prev',
                                    },
                                },


                            });
                        }, 1000);

                        this.isLoading = false;
                    } else {
                        if (result.length == 1) {
                            this.viewAcc(result[0], '/carrier/permit/application/mypermits');
                            this.isLoading = false;
                        }
                    }
                    this.isLoading = false;
                },
                (error) => {
                    this.isLoading = false;
                    this.isEmpty = true;

                    if (this.onboarding == 0) {
                        // this.showModal.showYesNo('New Accounts', 'Would you like to create an account in order to apply for permits?', '', 'Yes', 'No')
                        //               .subscribe((isConfirmed) => {
                        //   if (isConfirmed) {
                        //     this.router.navigate(['/carrier/account/add']);
                        //     this.isLoading = false;
                        //   } else {
                        //     return;
                        //   }
                        // });
                        this.confirmDialogService.confirmThis(
                            'Would you like to create an account in order to apply for a permit?',
                            () => {
                                this.router.navigate(['/carrier/account/add']);
                                this.isLoading = false;
                            },
                            () => {
                                return;
                            }
                        );
                    } else {
                        // this.showModal.showConfirm('Carrier Accounts', 'Would you like to create a new account or import your existing Account ?', 'If you are a consultant, close this message and then click Cancel. You will receive an invitation to link to an operator.', 'Create New Account', 'Import Existing Account')
                        //             .subscribe((isConfirmed) => {
                        //   if (isConfirmed) {
                        //     this.router.navigate(['/carrier/account/add']);
                        //     this.isLoading = false;
                        //   } else {
                        //     // document.querySelector("#modal-dialog").
                        //     $('#myModal').modal();
                        //     // return;
                        //   }
                        // });
                        this.confirmDialogService.confirmThis(
                            'Would you like to create an account ?',
                            () => {
                                this.router.navigate(['/carrier/account/add']);
                                this.isLoading = false;
                            },
                            () => {
                                $('#myModal').modal();
                            }
                        );
                    }
                }
            );
        }
    };

    //checkAllCheckBox(ev) { // Angular 9
    checkAllCheckBox(ev: any) {
        // Angular 13
        this.listAccounts.forEach((x) => (x.checked = ev.target.checked));
    }

    subChecked(ev: any, optionalVal, res, index) {
        console.log(index);
        this.countIndexes.push(index);
        console.log(this.countIndexes);
        this.selectedSub = ev.target.checked ? index : undefined;

        return;
    }

    CheckedCarrier(ev: any, optionalVal, res, index) {
        this.subsidiaryDataByIndex = res;
        console.log(this.subsidiaryDataByIndex, '@@@@@@@@@@@@@@@@@@');
        this.selectedIndex = ev.target.checked ? index : undefined;
        console.log(this.selectedIndex);

        if (ev.target.checked) {
            this.selectedcarrier = res;
            this.checked = true;
        } else {
            this.selectedcarrier = null;
            this.checked = false;
        }
    }

    onClickOCASLinks(link) {
        console.log(link);

        if (this.selectedcarrier == null) {
            this.toastService.error('You need to select carrier first!', '');
        } else {
            switch (link) {

                case 'AUDIT':
                    this.router.navigateByUrl(`/ocas/audit/${this.selectedcarrier.carrier_id}`);
                    break;
                case 'DEPOT':
                    this.router.navigate([
                        `/carrier-depot/list/${this.selectedcarrier.carrier_id}`,
                    ]);
                    break;
                case 'QUESTIONNAIRE':
                    this.subsidiaryDataByIndex.main_comp_ind === true &&
                    this.subsidiaryDataByIndex.main_carrier_id != null
                        ? this.toastService.error('You account is not Subsidiary', 'Error')
                        : this.router.navigate(['/ocas/questionnaire', this.selectedIndex]);
                    break;
                case 'DRIVER':
                    this.router.navigate([
                        `/carrier-driver/list/${this.selectedcarrier.carrier_id}`,
                    ]);
                    break;
                case 'VEHICLE':
                    this.router.navigate([
                        `permit/my-vehicles/${this.selectedcarrier.carrier_id}/${this.selectedcarrier.account_number}`,
                    ]);
            }
        }
    }

    doAction(event) {
        if (event.value === 'Annual Compliance') {
            console.log(event);
            this.router.navigate([`/annual-compliance/list/${this.selectedcarrier.carrier_id}`]);
            return;
        }
    }

    actionClicked(optionVal, res) {
        this.ocausId = res.id;
        switch (optionVal) {
            // Permits
            case 0:
                console.log('Permits');
                this.utility.isfromCarrier = false;
                this.viewAcc(res, '/carrier/permit/application/mypermits');
                break;
            // Applications
            case 1:
                this.viewAcc(res, '/carrier/permit/application');
                break;
            // View Account
            case 2:
                this.router.navigate(['/carrier/account/edit/' + res.id + '/' + 1]);

                break;
            // Edit Account
            case 3:
                this.router.navigate(['/carrier/account/edit', res.id]);
                break;
            // Delete Account
            case 4:
                this.deleteAccount(res);
                break;
            // Un-Submit
            case 5:
                this.unsubmitAccount(res);
                break;
            // Account Statement
            case 6:
                this.router.navigate([
                    'carrier/statement/' + res.carrier_account_id + '/' + res.id,
                ]);
                break;
            // Link Consultant
            case 7:
                this.router.navigate(['carrier/consultant/' + res.id]);
                break;
            // Annual Compliance
            // case 8:
            //   this.router.navigate([
            //     "/carrier/compliance/return/list/" + res.id + "/" + 0,
            //   ]);
            //   break;
            // Fund Account
            case 9:
                this.router.navigate(['/carrier/fundaccount/' + res.id]);
                break;
            //Ocaus
            case 10:
                this.router.navigate(['/ocas-stepper/' + res.id]);
                break;
            //My Permits
            case 11:
                this.utility.isfromCarrier = true;
                this.viewAcc(res, '/carrier/permit/application/mypermits');
                break;
            //monthly compliance
            case 12:
                console.log('this is whats in res', res)
                this.router.navigate(['monthly-compliance/list/' + res.id]);
                break;
            case 13:
                this.router.navigate(['carrier/reports/' + res.account_number]);
                break;

            case 14:

                this.router.navigateByUrl(
                    '/carrier/permit/application/new/' + res.id
                );
                break;
            default:
                break;
        }
    }

    isAllCheckBoxChecked() {
        return this.listAccounts.every((p) => p.checked);
    }

    isReadOnly = (status: string): boolean => {
        return status == 'Submitted';
    };

    viewAcc(list, url) {
        if (list.status == 'AccountStatus3') {
            this.toastService.error(
                'Your Carrier account has not been approved',
                'Error'
            );
            return false;
        } else {
            this.router.navigate([url, list.id]);
        }
    }

    selectOptionList(optionVal, res) {
        switch (optionVal) {
            // Permits
            case '0':
                this.viewAcc(res, '/carrier/permit/application/mypermits');
                break;
            // Applications
            case '1':
                this.viewAcc(res, '/carrier/permit/application');
                break;
            // View Account
            case '2':
                this.router.navigate(['/carrier/account/edit/' + res.id + '/' + 1]);
                break;
            // Edit Account
            case '3':
                this.router.navigate(['/carrier/account/edit', res.id]);
                break;
            // Delete Account
            case '4':
                this.deleteAccount(res);
                break;
            // Un-Submit
            case '5':
                this.unsubmitAccount(res);
                break;
            // Account Statement
            case '6':
                this.router.navigate([
                    'carrier/statement/' + res.carrier_account_id + '/' + res.id,
                ]);
                break;
            // Link Consultant
            case '7':
                this.router.navigate(['carrier/consultant/' + res.id]);
                break;
            // Annual Compliance
            case '8':
                this.router.navigate([
                    '/carrier/compliance/return/list/' + res.id + '/' + 0,
                ]);
                break;
            // Fund Account
            case '9':
                this.router.navigate(['/carrier/fundaccount/' + res.id]);
                break;
            //Ocaus
            case '10':
                this.router.navigate(['/ocas/questionnaire/' + res.id]);
            //Monthly Comps
            case '12':
                this.router.navigate(['monthly-compliance/list/' + res.id]);
                break;
            default:
                break;
        }
    }

    deleteAccount(acnt) {
        // this.showModal.showYesNo('Delete Account', 'Are you sure you want to delete account no.: ' + acnt.account_number + ' ?', `click the 'Yes' or 'No' button ->`, 'Yes', 'No').subscribe((userSelectedYes) => {
        //   if (userSelectedYes)
        //   {
        //     this.carrierService.delete(acnt.id).subscribe((msg:any) =>
        //       {
        //         if (msg == "There was a problem deleting the account.")
        //         {
        //           this.toaster.error(msg);
        //         }
        //         else
        //         {
        //           this.toaster.info("Account number " + acnt.account_number + " was successfully deleted.");
        //         }
        //       });
        //   }
        //   this.loadAccounts();
        // });
        if (acnt.status != 'Saved but not Submitted') {
            this.toastService.error(
                'Your account can\'t be deleted because the status is not \'Saved but not Submitted\'.',
                'Error'
            );
            return;
        }

        this.confirmDialogService.confirmThis(
            'Are you sure you want to delete account no.: ' +
            acnt.account_number +
            ' ?',
            () => {
                this.carrierService.delete(acnt.id).subscribe((msg: any) => {
                    if (msg == 'There was a problem deleting the account.') {
                        this.toaster.error(msg);
                    } else {
                        this.toastService.error(
                            'Account number ' +
                            acnt.account_number +
                            ' was successfully deleted.',
                            'Error'
                        );
                    }
                    window.location.reload();
                });
            },
            () => {
                //No here
            }
        );
    }

    unsubmitAccount(acnt, key = 2) {
        //     let obj: any = {}

        // this.showModal.showYesNo('Un-Submit Account', 'Are you sure you want to unsubmit account ' + acnt.account_number + ' ?', `click the 'Yes' or 'No' button =>`, 'Yes', 'No').subscribe((userSelectedYes) => {
        //   if (userSelectedYes)
        //   {
        //     this.carrierService.getCompanyDetailsById(acnt.id).subscribe((obj:any) => {
        //       this.utility.isChanged = false;
        //       obj.Carrier.status_id = parseInt(this.authWebService.userData.Configurations.find(c => c.Code == "AccountStatus1").Value);
        //       this.isLoading = true;
        //       this.updateCACDetails(obj, key);
        //       this.utility.landingPage();
        //     });
        //   }
        // });
        this.confirmDialogService.confirmThis(
            'Are you sure you want to unsubmit account ' + acnt.account_number + ' ?',
            () => {
                this.carrierService
                    .getCompanyDetailsById(acnt.id)
                    .subscribe((obj: any) => {
                        this.utility.isChanged = false;
                        obj.Carrier.status_id = parseInt(
                            this.authWebService.userData.Configurations.find(
                                (c) => c.Code == 'AccountStatus1'
                            ).Value
                        );
                        this.isLoading = true;
                        this.updateCACDetails(obj, key);
                        window.location.reload();
                        // this.utility.landingPage();
                    });
            },
            () => {
                //No here
            }
        );
    }

    updateCACDetails = (obj: any, key = 2) => {
        this.message = 'Updating carrier account\'s company details,please wait...';
        this.isLoading = true;
        this.carrierService.processUpdateCompanyDetails(obj).subscribe(
            (result) => {
                this.aCarrier = result;
                this.utility.docCtrl =
                    this.aCarrier.Carrier.carrier_id > 0 ? true : false;
                this.isLoading = false;
                this.utility.activeTab = key;
                this.toastService.success(
                    'Carrier Account successfully unsubmitted.',
                    'Carrier Account'
                );
                this.loadAccounts();
            },
            (error) => {
                this.isLoading = false;
                this.toastService.error(
                    'Could not unsubmit the Carrier Accout. Please contact the system administrator if the problem persists.',
                    'Carrier Account'
                );
                this.loadAccounts();
            }
        );
    };

    showSuccess(msg) {
        this.toastService.success(msg, 'Carrier Account UnSubmit');
    }

    showError = (msg) => {
        this.toastService.error(msg, 'Carrier Account UnSubmit');
    };

    fetchCarrier(carrCode) {
        this.isLoading = true;
        if (carrCode == '' || carrCode == undefined) {
            this.errorMessage = 'Please enter a valid carrier number';
            this.emptyCarrier = true;
            this.fetchedCarrier = false;
            this.isLoading = false;
        } else {
            this.emptyCarrier = false;

            let keyword: any = {};
            keyword.AccountNumber =
                carrCode != '' && carrCode != null ? carrCode : 'All';
            keyword.Suffix = 'All';
            keyword.Statuses = [];

            this.carrierService
                .searchCarrierAccounts(keyword, 1, 10, 6, true)
                .subscribe((result: any) => {
                    if (result.Count == 0) {
                        this.errorMessage = 'Carrier number was not found';
                        this.emptyCarrier = true;
                        this.fetchedCarrier = false;
                        this.isLoading = false;
                    } else {
                        this.carrierName = result.Accounts[0].Name;
                        this.carrierTradingName = result.Accounts[0].TradingName;
                        this.carrierType = result.Accounts[0].carrier_type;
                        this.carrierCountry = result.Accounts[0].country;

                        this.carrierId = result.Accounts[0].Id;

                        this.carrierService
                            .getCompanyDetailsById(result.Accounts[0].Id)
                            .subscribe((company: any) => {
                                if (
                                    company.Carrier.user_id == null ||
                                    company.Carrier.status_id == 93
                                ) {
                                    this.fetchedCarrier = true;
                                } else {
                                    this.msg.warning(
                                        `The carrier has already been assigned. [${company.Contact.EmailAddress}]`,
                                        `Carrier Import`
                                    ); // this.carrierName
                                    this.fetchedCarrier = false;
                                }

                                this.isLoading = false;
                            });
                    }
                });
        }
    }

    importCarrier() {
        this.importingCarrier = 'true';
        localStorage.setItem('importCarrier', this.importingCarrier);
        this.router.navigate(['/carrier/account/edit', this.carrierId]);
    }

    cancelCarrier() {
        $('#carrierCode ').val('');
        this.fetchedCarrier = false;
        return;
    }

    checkKey(event) {
        var carrierCode = document.getElementById('carrierCode');
        const charCode = event.which ? event.which : event.keyCode;
        if (charCode == 13) {
            this.fetchCarrier($('#carrierCode ').Value);
            return;
        }
    }

    setCarrierCodeFocus() {
        $('#myModal').on('shown.bs.modal', function () {
            $('#carrierCode').focus();
        });
    }

    onSortClick(colName, event) {
        let target = event.currentTarget,
            classList = target.classList;
        console.log(classList);
        if (classList.contains('fa-chevron-circle-up')) {
            classList.remove('fa-chevron-circle-up');
            classList.add('fa-chevron-circle-down');
            this.sortDir = -1;
        } else {
            classList.add('fa-chevron-circle-up');
            classList.remove('fa-chevron-circle-down');
            this.sortDir = 1;
        }
        this.sortArr(colName);
    }

    sortArr(colName: any) {
        this.listAccounts.sort((a, b) => {
            a = a[colName].toLowerCase();
            b = b[colName].toLowerCase();
            return a.localeCompare(b) * this.sortDir;
        });
    }

    // pager(event) {
    //   this.page = event;

    // }
    pager(event) {
        this.page = event;
    }

    onNextOrPrevious(page: number = 1) {
        this.loadAccounts(this.pageSize, page);
        this.currentPage = page;
        return page;
    }


    onCollapse(acc: any, index: any) {
        if (acc.iscollapsed) {
            acc.iscollapsed = false;
        } else {
            acc.iscollapsed = true;
        }
    }

    editAccount(res) {
        this.router.navigate(['/carrier/account/edit', res.id]);
    }

    onChange = (event) => {
        this.currentPage = 1;
        this.pageSize = event;
        // this.loadAccounts(this.pageSize,(this.utility.page = 1) );
    };


    searchCarrier() {
        this.filterCarrier.getData().subscribe((x) => {
            this.carrierService
                .listCarrierAccountsByUserId(this.user.Id, 100, this.currentPage)
                .subscribe((acc: any) => {
                    this.listAccounts = acc.data;
                    if (x) {
                        console.log(x);
                        if (x.carrierName != null) {
                            this.listAccounts = this.listAccounts.filter((a) =>
                                a.account_name
                                    .toLowerCase()
                                    .includes(x.carrierName.toLowerCase())
                            );
                        }
                        if (x.carrierAccountNumber != null) {
                            console.log(x); //carrierAccountNumber carrierName
                            this.listAccounts = this.listAccounts.filter((a) =>
                                a.account_number
                                    .toLowerCase()
                                    .includes(x.carrierAccountNumber.toLowerCase())
                            );
                        }

                        //this.listAccounts.filter(a =>  a.account_number.toLowerCase().indexOf(x.carrierAccountNumber) !== -1 || a.account_name.toLowerCase().indexOf(x.carrierName) !== -1);

                        if (x.statusMultiSelect?.length > 0) {
                            for (var i = 0; i < x.statusMultiSelect?.length; i++) {
                                this.listAccounts = this.listAccounts.filter(
                                    (s) => s.status == x.statusMultiSelect[i].desc
                                );
                            }
                        }
                    }
                });
        });
    }

    getOppositeSignValue(value: number): number {
        return value * -1;
      }
}
